import * as React from 'react';

function CrashIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="100%" height="100%" viewBox="0 0 19 19" fill="none" {...props}>
			<path
				d="M5.901 11.01l-.001.02.003.024a.11.11 0 00.031.061l1.393 1.393a.108.108 0 00.062.032l.023.003.021-.002a12.83 12.83 0 001.467-.257L6.158 9.543c-.113.48-.198.969-.257 1.466zM16.009 2.344a9.853 9.853 0 00-7.041 2.903A9.804 9.804 0 006.5 9.337l2.606 2.607a9.797 9.797 0 004.091-2.468 9.84 9.84 0 002.903-7.04.093.093 0 00-.092-.092zm-3.155 5.35a1.49 1.49 0 01-2.103-.002 1.49 1.49 0 010-2.102 1.49 1.49 0 012.104-.001c.58.58.58 1.525 0 2.105zM4.688 14.46a.254.254 0 01-.393 0 .35.35 0 010-.448l1.435-1.64c-.748-.636-1.813-.568-2.49.207-.727.83-.932 3.917-.94 4.048a.115.115 0 00.028.083c.02.022.044.033.071.031.115-.009 2.816-.243 3.543-1.074.678-.774.738-1.99.18-2.845L4.689 14.46zM8.9 12.948l1.467 2.545a.108.108 0 00.078.05.122.122 0 00.092-.026l2.532-2.228a.087.087 0 00.03-.082l-.362-1.863A12.485 12.485 0 018.9 12.948zM2.958 8.076l2.909 1.468A11.743 11.743 0 017.7 5.708l-2.131-.363a.11.11 0 00-.094.03l-2.544 2.53a.109.109 0 00-.03.093c.003.02.015.042.03.057a.278.278 0 00.027.02z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default CrashIcon;
